// Tiny dev-only logger. Silenced in production builds.
const isDev = process.env.NODE_ENV !== "production";

const logger = {
  error: (...args) => {
    if (isDev) {
      console.error(...args);
    }
  },
  warn: (...args) => {
    if (isDev) {
      console.warn(...args);
    }
  },
};

export default logger;
